/** Dependencies */
import EndOfDayDetails from './EndOfDayDetails';
import EndOfDayWizard from './EndOfDayWizard';

export { EndOfDayWizard };

export default EndOfDayDetails;
